import { createReducer, on } from '@ngrx/store';
import { CountImoveisUsuario, Usuario } from '@shared/models/usuario/usuario.model';
import {
  adicionarImovelInteresseCotizacao,
  markNotificationsViewed,
  setUserData,
  updateCountImoveis,
  updateOrdenacaoColunaGerenciamentoImoveis,
  updateUserData,
} from '../actions/user.action';

export const initialState: Partial<Usuario> | undefined = undefined;

export const userReducer = createReducer(
  initialState,
  on(updateUserData, (state, userData) => ({ ...state, ...userData })),
  on(updateCountImoveis, (state, { incrementBy, property }) => ({
    ...state,
    countImoveis: {
      ...state?.countImoveis,
      [property]: (state.countImoveis?.[property] ?? 0) + incrementBy,
    },
  })),
  on(adicionarImovelInteresseCotizacao, (state, { by }) => {
    const currentCountImoveis = state.countImoveis;
    let newCountImoveis: CountImoveisUsuario;
    if (!state.countImoveis.imoveisInteresseCotizacao) {
      newCountImoveis = {
        ...currentCountImoveis,
        imoveisInteresseCotizacao: by,
      };
    } else {
      const currentCountInteresseCotizacao = state.countImoveis.imoveisInteresseCotizacao;
      newCountImoveis = {
        ...currentCountImoveis,
        imoveisInteresseCotizacao: currentCountInteresseCotizacao + by,
      };
    }
    return {
      ...state,
      countImoveis: newCountImoveis,
    };
  }),
  on(setUserData, (state, userData) => ({
    ...state,
    ...userData,
  })),
  on(markNotificationsViewed, (state, { notificationIds }) => {
    if (!state?.notificationData) return state;
    const ids = new Set(notificationIds);
    return {
      ...state,
      notificationData: {
        ...state.notificationData,
        newNotifications: 0,
        lastNotifications: (state.notificationData.lastNotifications ?? []).map((n) =>
          !n.viewed && ids.has(n.id) ? { ...n, viewed: true } : n,
        ),
      },
    };
  }),
  on(updateOrdenacaoColunaGerenciamentoImoveis, (state, ordenacaoColuna )=>{
    const key = Object.keys(ordenacaoColuna)[0];
    const newOrdenacaoObj = {
      ...state.gerenciamentoImoveisConfig?.ordenacaoColunas,
      [key]: {
        ...state.gerenciamentoImoveisConfig?.ordenacaoColunas?.[key],
        ...ordenacaoColuna[key]
      }
    };

    return {
      ...state,
      gerenciamentoImoveisConfig: {
        ...state.gerenciamentoImoveisConfig,
        ordenacaoColunas: {
          ...state.gerenciamentoImoveisConfig.ordenacaoColunas,
          ...newOrdenacaoObj
        }
      }
    }
  })
);
